import { createStrings } from '@utils/local';
import type { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '予約作成',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: true,
  staffOnly: true,
  order: 6,
};
